import React from 'react';
import SpinnerBase from './SpinnerBase';
import styled from 'styled-components';

const SpinnerWrap = styled(SpinnerBase)`
  @keyframes spin {
    to {
      transform: rotate(360deg);
    }
  }

  animation: spin 1s linear infinite;
`;

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-items: center;
  align-items: center;
`;

const TextWrapper = styled.span`
  margin-top: 4px;
  font-family: 'Inter';
`;

const Spinner = ({ className, style, tip, width = 48, height = 48, ...props }) => (
  <Wrapper>
    <SpinnerWrap data-testid='SpinnerWrap' className={className} style={style} width={width} height={height} {...props} />
    {tip && <TextWrapper>{tip}</TextWrapper>}
  </Wrapper>
);

export default Spinner;
